<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
    <v-row id="atualizacao-descricao" class="mx-auto">
      <v-col cols="12">
        <v-text-field id="fs-descricao-atualizacao-bdgd" v-model="descricao" label="Descrição (opcional)" outlined />
      </v-col>
    </v-row>
    <v-row id="atualizacao-empresa" class="mx-auto">
      <v-col cols="12">
        <select-company
          id="fs-empresa-atualizacao-bdgd"
          :type="'outlined'"
          :selectedCompany="userLoggedCompany"
          @companySelected="companySelected"
        />
      </v-col>
    </v-row>
    <v-row v-if="companyId" id="atualizacao-versao-bdgd" class="mx-auto">
      <v-col cols="12">
        <select-all-bdgd-versions
          label="Versão da BDGD"
          type="outlined"
          :showIcon="false"
          :companyId="companyId"
          :esconderBloqueadasParaUsuarioAtual="true"
          @bdgdVersionSelected="bdgdVersionSelected"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'FirstTabContent',
    components: {
      SelectCompany: () => import('@/components/general/SelectCompany.vue'),
      SelectAllBdgdVersions: () => import('@/components/general/SelectAllBdgdVersions.vue')
    },
    data() {
      return {
        descricao: null,
        companyId: null,
        bdgdVersion: null
      };
    },
    computed: {
      userLoggedCompany() {
        return this.$store.getters.getSelectedCompany;
      }
    },
    methods: {
      companySelected(company) {
        this.companyId = company.id;
      },
      bdgdVersionSelected(bdgdVersion) {
        this.bdgdVersion = bdgdVersion;
      },
      emitEventAtualizacaoUpdated() {
        this.$emit('atualizacao:updated', {
          descricao: this.descricao,
          companyId: this.companyId,
          bdgdVersion: this.bdgdVersion
        });
      }
    },
    watch: {
      descricao() {
        this.emitEventAtualizacaoUpdated();
      },
      companyId() {
        this.emitEventAtualizacaoUpdated();
      },
      bdgdVersion() {
        this.emitEventAtualizacaoUpdated();
      }
    }
  };
</script>
